export const COLORS = {
  ACCENT: '#fdcc08',
  PRIMARY: '#00a4ad',
  PRIMARY_DARKEN_1: '#00949c',
  PRIMARY_DARKEN_2: '#00838a',
  SUCCESS: '#4CAF50',
  ERROR: '#e8442d',
  WARNING: '#FF9800',
  INFO: '#2196F3',
  GREY: '#a5adb7',
  BLACK: '#000',
  WHITE: '#fff',
};

export const GRID_LINE_COLOR = COLORS.BLACK;

export const BASE_UNIT = 4;
export const REM = BASE_UNIT * 4;
